import styled, { css } from 'styled-components'
import { ReactComponent as Cancelar } from "../../../assets/icons/cancelar.svg";

interface PropsFormControl {
  actived: boolean;
  disabled: boolean;
  error: boolean;
  selected: boolean;
}

export const FormControl = styled.div<PropsFormControl>`
  display: flex;
  flex-direction: column;
  width: 100%;
  .chevron__container{
    transform: translateY(13px);
    ${props => props.theme.motion}
    transition-property: transform;
  }
  .chevron__line1,
  .chevron__line2{
    ${props => props.theme.motion}
    stroke-width: 10;
    stroke-linecap: round;
    stroke: currentColor;
    transform-origin: 50px 50px;
  }
  .chevron__line1 {
    transform: rotate(40deg);
  }
  .chevron__line2 {
    transform: rotate(-40deg);
  }
  ${props => props.actived && css`
    .chevron__container{
      transform: translateY(-13px);
    }
    .chevron__line1,
    .chevron__line2{

    }
    .chevron__line1 {
      transform: rotate(-40deg);
    }
    .chevron__line2 {
      transform: rotate(40deg);
    }
  `}

  ${props => !props.disabled && css`
    &:hover {
      button {
        ${props => props.theme.states.hover.select}
      }
    }
  `}

  ${props => props.actived && css`
    .tmp-select__label{
      ${props => props.theme.states.actived.label}
    }

    button {
      ${props => props.theme.states.actived.select}
    }

    div {
      ${props => props.theme.states.actived.select}
    }
  `}

  ${props => props.error && css`
    .tmp-select__label{
      ${props => props.theme.states.error.label}
    }

    button {
      ${props => props.theme.states.error.select}
    }
    .tmp-select__helper{
      ${props => props.theme.states.error.helper}
    }
    span{
      ${props => props.theme.states.error.helper}
    }
  `}

  ${props => props.disabled && css`
    .tmp-select__label{
      ${props => props.theme.states.disabled.label}
    }

    button {
      ${props => props.theme.states.disabled.select}
      ${props => props.theme.states.disabled.placeholder}
    }
    .tmp-select__helper{
      ${props => props.theme.states.disabled.helper}
    }
  `}

`

 

export const Label2 = styled.label`
  ${props => props.theme.label};
`

export const FormControlInput = styled.div`

  align-items: center;
  display: -webkit-box; 

  min-width: 312px;
  min-height: 49px;
  background-color: #FFFFFF;
  border-radius: 8px;
  border: 1px solid #292929;
  
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 4px;
  padding-bottom: 1px;

`
export const AlignContentCenter = styled.div`
  width: 100%;
  display: flex;
  justifyContent: "center";
`

export const WidhtControlInput = styled.div`
  width: 100%;
`
export const FormControlTagsInput = styled.div`
  
  flex-wrap: wrap;
  width: 100%;
  cursor: text;
  display: inline-flex;
  align-items: center;
  letter-spacing: 0.00938em;
`

export const TagControl = styled.div`
  margin: 3px;
  max-width: calc(100% - 6px);
  height: 32px;
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;

  border-radius: 4px;
  border: 1px solid #2C6EF2;
  padding: 0 4px 0 8px;
  color: #2C6EF2;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;

  -webkit-transition-duration: 0.275s;
  transition-duration: 0.275s;
  -webkit-transition-timing-function: cubic-bezier(0.48,0,0.48,1);
  transition-timing-function: cubic-bezier(0.48,0,0.48,1);

  svg{
    color: #2C6EF2;
    width: 16px;
    cursor: pointer;
    height: 16px;
    -webkit-tap-highlight-color: transparent;

    display: inline-block;
    font-size: 1.5rem;
    transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }

`

export const TagLabel = styled.div`
  overflow: hidden;
  white-space: nowrap;
  padding-left: 6px;
  padding-right: 12px;  
`


export const RemoverItemStyledIcon = styled(Cancelar)`
  cursor: pointer;
  margin: 0 5px 0 -6px;
  fill: currentColor;
  width: 20px;
  font-size: 1.5rem;
  -ms-flex-negative: 0;
  -moz-user-select: none;
  -ms-user-select: none;
  color: #2C6EF2;

`;



export const InputSearch = styled.input`
  padding: 4px;
  min-width: 30px;
  background: transparent;
  border: none;
  outline: none;

  opacity: 1;
  flex-grow: 1;
  text-overflow: ellipsis;
  font: inherit;
  color: currentColor;
  border: 0;
  height: 1.1876em;
  margin: 0;
  
  background: none;
  box-sizing: content-box;
  letter-spacing: inherit;
  
  width: auto;
  text-transform: none;
  
  line-height: 100%;
  font-weight: 400;
  font-size: 16px;
  font-family: Inter;
  text-align: left;
`

export const Select = styled.div`
  position: relative;
`

interface PropsOptions {
  actived: boolean;
  disabled: boolean;
  selected: number;
}

export const OptionsList = styled.ol<PropsOptions>`
  list-style-type: none;
  position: absolute;
  margin: 0;
  padding: 0;
  min-width: 100%;
  width: max-content;
  height: auto;
  max-height: 350px;
  overflow-y: auto;
  box-sizing: border-box;

  display: none;
  z-index: 2;

  ${props => props.theme.menuItem}

  ${props => props.actived && css`
    display: block;
    opacity: 1;
  `}

  .tmp-list-item{
    border-bottom: 0;
    ${props => props.theme.menuItemLabel}

    &:focus-visible {
      ${props => props.theme.states.focus}
    }

    span{

    }
  }

  ${props => props.selected !== undefined && css`
    .tmp-list-item:nth-of-type(${props.selected + 1}){
      ${props.theme.states.actived.menuItemLabel}
      span{
        color: currentColor;
      }

    }
  `}

  .tmp-list-item:last-of-type{
    border-color: transparent;
  }
`

export const Helper = styled.span`
  display: flex;
  ${props => props.theme.helper};
  .icon {
    ${props => props.theme.helper.icon};
  }
`
